import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
  SIGN_UP,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAIL,
  SET_HEADERS,
  IS_REQUESTING_RESET,
  IS_REQUESTING_SUCCESS,
  SET_EMAIL_RESET_PASSWORD,
  CHANGING_PASSWORD,
  RESET_AUTH_STORE
} from '../mutationTypes'
import router from '@/router'
import i18n from '../../internatinalization/i18n'
import api from '@/axiosConfig'
import _ from 'lodash'
import { ValidateEmail, status, layouts } from '../../helpers'
const gemnoteAPI = api()

var CryptoJS = require('crypto-js')
// import { decryptRouteQuery } from '../../../encryption'

export default {
  /**
   * sets headers with every response based on credentials in response headers
   *
   * @param {Object} authHeaders - all auth headers
   * @param {String} authHeaders['access-token'] - response header
   * @param {String} authHeaders['client'] - response header
   * @param {String} authHeaders['expiry'] - response header
   * @param {String} authHeaders['uid'] - response header
   * @param {String} authHeaders['token-type'] - response header
   */
  async setHeaders({ commit }, authHeaders) {
    commit(SET_HEADERS, authHeaders)
  },
  async signUp({ commit, dispatch }, newUserInfo) {
    commit(SIGN_UP)
    try {
      let isValidEmail = ValidateEmail(newUserInfo.email)
      let errors = []
      if (!isValidEmail)
        errors.push('You have entered an invalid email address!')
      if (!newUserInfo.password) errors.push(`Password can't be blank!`)
      if (!newUserInfo.teamName) errors.push(`Team name can't be blank!`)
      if (!newUserInfo.password) errors.push(`Password can't be blank!`)
      if (!newUserInfo.rePassword)
        errors.push(`Re-type password can't be blank!`)
      if (newUserInfo.password !== newUserInfo.rePassword)
        errors.push(`Password and Re-type must be the same!`)

      if (errors.length > 0) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
        return
      } else {
        let userObject = {
          user: {
            email: newUserInfo.email,
            password: newUserInfo.password
          },
          team: {
            name: newUserInfo.teamName
          }
        }
        await gemnoteAPI.post('auth', userObject)
        commit(SIGN_UP_SUCCESS)
        dispatch(
          'auth/login',
          {
            email: newUserInfo.email,
            password: newUserInfo.password,
            fromSignUp: true
          },
          { root: true }
        )
      }
    } catch (error) {
      console.log(error)
      commit(SIGN_UP_FAIL)
      let errors = []
      if (error.response) {
        if (error.response.status === 404 || error.response.status === 500) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [`${error.response.statusText}`]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(
          `The request was made but no response was received from the server.`
        )
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push('An exception ocurred while trying to signup a new user.')
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },

  /**
   * logs in a user, saves the response headers in a cookie
   *
   * @param {Object} credentials - object to send to server, containing user info
   * @param {String} credentials.email - user email
   * @param {String} credentials.password - user password
   * @param {Boolean} credentials.fromSignUp - determines if from signup flow or not
   */
  async login({ commit, dispatch }, credentials) {
    commit(LOGIN)
    try {
      let tokenResponse = await gemnoteAPI.post('auth/sign_in', {
        user: _.pick(credentials, ['email', 'password'])
      })

      const authHeaders = {
        'access-token': tokenResponse.headers['access-token'],
        client: tokenResponse.headers['client'],
        expiry: tokenResponse.headers['expiry'],
        uid: tokenResponse.headers['uid'],
        'token-type': tokenResponse.headers['token-type']
      }

      const cookieContents = {
        tokens: authHeaders
      }
      window.$cookies.remove('recipient-session')
      window.$cookies.set('dashboard-session', cookieContents)
      await dispatch('setHeaders', authHeaders)
      await dispatch(
        'profile/getProfile',
        { reloadProfile: false },
        { root: true }
      )
      await dispatch(
        'team/getTeam',
        team => {
          // check if team is beta team

          let betaTeamIds = process.env.VUE_APP_BETA_TEAM_IDS
            ? process.env.VUE_APP_BETA_TEAM_IDS.split(',')
            : []

          console.log({ betaTeamIds })
          let isBetaTeam = betaTeamIds.includes(team.id)
          if (isBetaTeam) {
            // encode team and auth string in Base64
            const teamString = btoa(JSON.stringify(team))
            const authString = btoa(JSON.stringify(authHeaders))

            console.log(authString)

            // Encrypt auth and team string
            let betaQueries = CryptoJS.AES.encrypt(
              JSON.stringify({ teamString, authString }),
              process.env.VUE_APP_SECRET_KEY
            ).toString()

            // var betaQueries = decryptRouteQuery({teamString, authString})

            // encode query for routing
            let betaRouteMeta = encodeURIComponent(betaQueries)

            // route to beta redirect link
            window.location.href = `${process.env.VUE_APP_BETA_URL}?q=${betaRouteMeta}`
          }
        },
        { root: true }
      )
      // get current subscription
      await dispatch('billing/getCurrentSubscription', {}, { root: true })

      let protectedLastRoute = localStorage.getItem('protectedLastRoute')
      let protectedLastRouteParams = JSON.parse(
        localStorage.getItem('protectedLastRouteParams')
      )

      if (credentials.fromSignUp) {
        router.push({ name: 'howitworks' })
      } else if (
        protectedLastRoute !== null &&
        protectedLastRoute !== undefined
      ) {
        if (Object.keys(protectedLastRouteParams).length > 0) {
          router.push({
            name: protectedLastRoute,
            params: protectedLastRouteParams
          })
        } else {
          router.push({ name: protectedLastRoute })
        }
      } else {
        dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD, {
          root: true
        })
        router.push({ name: 'report' })
      }
      commit(LOGIN_SUCCESS)
    } catch (error) {
      console.log(error)
      commit(LOGIN_FAIL)
      if (!credentials.fromInvitation) {
        let errors = []
        if (error.response) {
          if (error.response.status === 500 || error.response.status === 404) {
            dispatch(
              'notification/pushNotification',
              {
                type: 'error',
                messages: [
                  error.response.status === 500
                    ? i18n.t('server.server-error')
                    : i18n.t('server.not-found')
                ]
              },
              { root: true }
            )
          } else {
            let { errors } = error.response.data
            dispatch(
              'notification/pushNotification',
              {
                type: 'error',
                messages: errors
              },
              { root: true }
            )
          }
        } else if (error.request) {
          errors.push(i18n.t('server.no-response'))
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        } else {
          errors.push(i18n.t('login.action.login-error'))
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      }
    }
  },

  async handleSession({ dispatch }, tokenResponse) {
    const authHeaders = {
      'access-token': tokenResponse.headers['access-token'],
      client: tokenResponse.headers['client'],
      expiry: tokenResponse.headers['expiry'],
      uid: tokenResponse.headers['uid'],
      'token-type': tokenResponse.headers['token-type']
    }

    const cookieContents = {
      tokens: authHeaders
    }
    window.$cookies.remove('recipient-session')
    window.$cookies.set('dashboard-session', cookieContents)
    await dispatch('setHeaders', authHeaders)
    await dispatch(
      'profile/getProfile',
      { reloadProfile: false },
      { root: true }
    )
    await dispatch('team/getTeam', {}, { root: true })
    // get current subscription
    await dispatch('billing/getCurrentSubscription', {}, { root: true })
  },

  async oktaSignIn({ commit, dispatch }, { teamName, RelayState }) {
    try {
      commit(LOGIN)
      const response = await gemnoteAPI.get(
        `saml/sign_in${teamName ? `?team_name=${teamName}` : ''}`
      )

      if (response.data.error) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [response.data.error]
          },
          { root: true }
        )
        commit(LOGIN_FAIL)
        return
      }

      if (response.data.url) {
        if (RelayState) {
          console.log(response.data.url + `?RelayState=${RelayState}`)
          window.location.href = response.data.url + `?RelayState=${RelayState}`
        } else {
          window.location.href = response.data.url
        }
      }

      commit(LOGIN_SUCCESS)
    } catch (error) {
      console.log(error)
      commit(LOGIN_FAIL)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('login.action.login-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async oktaLogin({ commit, dispatch }, payload) {
    try {
      const response = await gemnoteAPI.post('saml/login', {
        okta_auth_token: payload.okta_auth_token
      })
      if (payload.isGroupOrder) {
        const data = response.data.data
        if (data) {
          await dispatch('groupOrder/createOktaRecipient', data, { root: true })
        }

        return
      }
      if (payload.isProjectOrder) {
        const data = response.data.data
        if (data) {
          dispatch(
            'project/updateOktaRecipient',
            {
              email: data.email,
              uuid: payload.uuid
            },
            { root: true }
          )
        }

        return
      }
      await dispatch('handleSession', response)
      router.push({ name: 'report' })
    } catch (error) {
      console.log(error)
      commit(LOGIN_FAIL)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('login.action.login-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },

  async fetchGoogleLoginUrl({ commit }, { RelayState }) {
    try {
      commit(LOGIN)
      const response = await gemnoteAPI.get('google_authentication')

      if (response.data.url) {
        if (RelayState) {
          window.location.href = response.data.url + `?RelayState=${RelayState}`
        } else {
          window.location.href = response.data.url
        }
      }
      commit(LOGIN_SUCCESS)
    } catch (error) {
      commit(LOGIN_FAIL)
    }
  },

  async verifyGoogleToken(
    { commit, dispatch },
    { google_auth_token, isProjectOrder, isGroupOrder }
  ) {
    try {
      const response = await gemnoteAPI.post('google_sign_in', {
        google_auth_token: google_auth_token
      })

      if (isGroupOrder) {
        const data = response.data.data
        if (data) {
          await dispatch('groupOrder/createOktaRecipient', data, { root: true })
        }

        return
      }

      if (isProjectOrder) {
        const data = response.data.data
        if (data) {
          dispatch(
            'project/sendRecipientVerificationEmail',
            {
              email: data.email,
              password: '',
              uuid: data.id,
              resend: true
            },
            { root: true }
          )
        }

        return
      }

      await dispatch('handleSession', response)
      router.push({ name: 'report' })
    } catch (error) {
      commit(LOGIN_FAIL)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('login.action.login-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },

  async logout({ commit, dispatch }) {
    commit(LOGOUT)
    try {
      const response = await gemnoteAPI.delete('auth/sign_out')
      const data = response.data
      if (!data.success) throw data
      window.$cookies.remove('dashboard-session')
      router.push({ name: 'login' }).then(() => {
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('logout.action.logout-success')]
          },
          { root: true }
        )
        commit(LOGOUT_SUCCESS)
        localStorage.removeItem('selectedCard')
        localStorage.removeItem('localCart')
        localStorage.removeItem('protectedLastRoute')
        localStorage.removeItem('protectedLastRouteParams')
        dispatch('resetStore')
      })
    } catch (error) {
      console.log(error)
      localStorage.removeItem('protectedLastRoute')
      localStorage.removeItem('protectedLastRouteParams')
      let errors = []
      commit(LOGOUT_FAIL)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('logout.action.logout-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async changePassword({ commit, dispatch }, { password, reTypePassword }) {
    try {
      let errors = []
      if (!password) errors.push(i18n.t('validations.blank-password'))
      if (!reTypePassword)
        errors.push(i18n.t('validations.blank-password-retype'))
      if (password.length < 6 || reTypePassword.length < 6)
        errors.push(i18n.t('validations.short-password'))
      if (password !== reTypePassword)
        errors.push(i18n.t('validations.not-matched-passwords'))

      if (errors.length > 0) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
        commit(CHANGING_PASSWORD, status.ERROR)
        return
      }
      commit(CHANGING_PASSWORD, status.LOADING)

      let userObject = {
        user: {
          password: password,
          password_confirmation: reTypePassword
        }
      }
      let changePasswordResponse = await gemnoteAPI.put(
        'auth/password',
        userObject
      )

      if (changePasswordResponse.data.success) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('profile.action.change-password-success')]
          },
          { root: true }
        )
        commit(CHANGING_PASSWORD, status.LOADED)
      } else {
        let { full_messages } = changePasswordResponse.errors
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: full_messages
          },
          { root: true }
        )
        commit(CHANGING_PASSWORD, status.ERROR)
      }
    } catch (error) {
      console.log(error)
      let errors = []
      commit(CHANGING_PASSWORD, status.ERROR)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { full_messages } = error.response.data.errors
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: full_messages
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('profile.action.change-password-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async setUserEmail({ commit }, userEmail) {
    commit(SET_EMAIL_RESET_PASSWORD, userEmail)
  },
  async resetPassword({ commit, dispatch }, data) {
    try {
      const { email } = data

      commit(IS_REQUESTING_RESET, true)
      let isValidEmail = ValidateEmail(email)
      let errors = []
      if (!isValidEmail) errors.push(i18n.t('validations.invalid-email'))

      if (errors.length > 0) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
        commit(IS_REQUESTING_RESET, false)
        return
      } else {
        let userObject = {
          user: {
            email: email
          }
        }
        let resetPasswordResponse = await gemnoteAPI.post(
          'auth/password',
          userObject
        )

        if (resetPasswordResponse.data.success) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'success',
              messages: [
                i18n.t('reset-pwd.action.reset-success', {
                  '0': email
                })
              ]
            },
            { root: true }
          )
          commit(IS_REQUESTING_SUCCESS, true)
          commit(IS_REQUESTING_RESET, false)
        } else {
          errors.push(resetPasswordResponse.data.message)
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
          commit(IS_REQUESTING_RESET, false)
          commit(IS_REQUESTING_SUCCESS, false)
        }
      }
    } catch (error) {
      console.log(error)
      commit(IS_REQUESTING_RESET, false)
      commit(IS_REQUESTING_SUCCESS, false)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('reset-pwd.action.reset-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async resetUserPassword({ dispatch }, { password, reTypePassword, token }) {
    try {
      let errors = []
      if (!token) errors.push(i18n.t('validations.token-required'))
      if (!password) errors.push(i18n.t('validations.blank-password'))
      if (!reTypePassword)
        errors.push(i18n.t('validations.blank-password-retype'))
      if (password.length < 6 || reTypePassword.length < 6)
        errors.push(i18n.t('validations.short-password'))
      if (password !== reTypePassword)
        errors.push(i18n.t('validations.not-matched-passwords'))

      if (errors.length > 0) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
        return
      }

      let userObject = {
        user: {
          password: password,
          password_confirmation: reTypePassword,
          reset_password_token: token
        }
      }
      let resetPasswordResponse = await gemnoteAPI.put(
        'auth/password',
        userObject
      )

      if (resetPasswordResponse.data.success) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [resetPasswordResponse.data.message]
          },
          { root: true }
        )
        let credentials = {
          email: resetPasswordResponse.data.data.email,
          password: password,
          fromSignUp: false
        }
        dispatch('login', credentials)
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: resetPasswordResponse.data.errors.full_messages
          },
          { root: true }
        )
      }
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { full_messages } = error.response.data.errors
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: full_messages
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('confirm-reset.action.confirm-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  closeCurrentSession({ dispatch }) {
    window.$cookies.remove('dashboard-session')
    localStorage.removeItem('protectedLastRoute')
    localStorage.removeItem('protectedLastRouteParams')
    router.push({ name: 'login' })
    dispatch('resetStore')
  },
  resetAuthState({ commit }) {
    commit(RESET_AUTH_STORE)
  },
  resetStore({ dispatch }) {
    dispatch('order/resetOrderState', {}, { root: true })
    dispatch('team/resetTeamState', {}, { root: true })
    dispatch('recipient/resetRecipientState', {}, { root: true })
    dispatch('product/resetProductState', {}, { root: true })
    dispatch('report/resetReportState', {}, { root: true })
    dispatch('profile/resetProfileState', {}, { root: true })
    dispatch('cardTemplate/resetCardTemplateState', {}, { root: true })
    dispatch('integration/resetIntegrationsState', {}, { root: true })
    dispatch('groupOrder/resetGroupOrderState', {}, { root: true })
    dispatch('billing/resetBillingState', {}, { root: true })
    dispatch('resetAuthState')
  }
}
